<template>
    <section class="container mt-5">
        <div>
          <Breadcrumb :blogId="blogId"></Breadcrumb>
          <div v-if="blog">
              <h1>{{ blog.post_title }}</h1>
              <img class="img-blog-title" :src="blog.post_image_url" :alt="blog.post_title">
              <div class="d-lg-flex justify-content-between align-items-baseline detail">
                  <div>
                      <p class="created-by">By BeNeat<span class="mx-5"><i class="time"></i>{{ blog.updated_at | prettyOnlyDateBE }}</span></p>
                  </div>
                  <div>
                      แชร์:
                      <a :href="`https://www.facebook.com/sharer/sharer.php?u=${url}`" target="_blank"><img src="/static/img/socialMedie/facebook.png" class="img-icon-share"></a>
                      <a :href="`https://x.com/intent/post?text=+${url}`" target="_blank"><img src="/static/img/socialMedie/x.png" class="img-icon-share"></a>
                      <a :href="`https://social-plugins.line.me/lineit/share?url=${url}&text=text`" target="_blank"><img src="/static/img/socialMedie/line.png" class="img-icon-share"></a>
                      <a href="" @click.prevent="copyURL()" ref="mylink"><img src="/static/img/socialMedie/chain.png" class="img-icon-share"></a>
                  </div>
              </div>
              <div v-html="blog.post_content" id="htmlContainer" class="mt-3"></div>
          </div>
          <div v-else>
            <h3 class="text-center">ไม่พบข้อมูล</h3>
          </div>
        </div>
        <!-- <h1>บ้านสกปรก ฝุ่นละอองในบ้าน ภัยเงียบที่คุกคามสุขภาพของคุณ</h1>  -->
            
            <!-- <p>บ้านควรเป็นสถานที่ที่เราสามารถพักผ่อนและรู้สึกปลอดภัย แต่คุณรู้หรือไม่ว่าภายในบ้านที่ดูสะอาดสะอ้านนั้นอาจซ่อนภัยเงียบที่คุกคามสุขภาพของคุณได้? ฝุ่นละอองในบ้านคือหนึ่งในภัยเงียบที่หลายคนมองข้าม แม้ว่าจะดูเป็นเรื่องเล็กน้อย แต่ฝุ่นละอองเหล่านี้สามารถส่งผลกระทบต่อสุขภาพของคุณและคนในครอบครัวได้อย่างมาก ในบทความนี้ เราจะสำรวจผลกระทบของฝุ่นละอองในบ้านและวิธีจัดการกับมันเพื่อสุขภาพที่ดีของคุณ</p>
            <p>หากคุณไม่มีเวลาหรือไม่สะดวกในการทำความสะอาดบ้านเอง การเรียกใช้บริการแม่บ้านออนไลน์จาก BeNeat เป็นทางเลือกที่สะดวกและมีประสิทธิภาพ BeNeat มีแม่บ้านมืออาชีพที่ผ่านการฝึกฝนมาอย่างดี พร้อมช่วยจัดการฝุ่นละอองและทำความสะอาดบ้านของคุณให้สะอาดหมดจด เพื่อให้คุณมั่นใจได้ว่า บ้านจะปลอดภัยและเป็นสถานที่ที่เหมาะกับการพักผ่อนอย่างแท้จริง</p>
        
            <h3>ฝุ่นละอองในบ้าน: ภัยเงียบที่ไม่ควรมองข้าม</h3>
            <p>ฝุ่นละอองในบ้านคืออนุภาคเล็กๆ ที่มองไม่เห็นด้วยตาเปล่า ประกอบไปด้วยเส้นใยผ้า ขนสัตว์ ละอองเกสร เชื้อรา และสารก่อภูมิแพ้อื่นๆ แม้ว่าฝุ่นละอองเหล่านี้อาจดูไม่มีอันตราย แต่การสะสมของฝุ่นละอองในบ้านที่สกปรกสามารถทำให้เกิดปัญหาสุขภาพได้ โดยเฉพาะในผู้ที่มีปัญหาเกี่ยวกับระบบทางเดินหายใจ เช่น โรคหืด ภูมิแพ้ และปอดอักเสบ</p>

            <h3>ผลกระทบของฝุ่นละอองต่อสุขภาพ</h3> 
            <ul>
              <li class="a"><strong>ปัญหาระบบทางเดินหายใจ:</strong> ฝุ่นละอองในบ้านสามารถทำให้เกิดการระคายเคืองต่อระบบทางเดินหายใจ ทำให้หายใจลำบาก หอบเหนื่อย และอาจเป็นสาเหตุของโรคหืดในบางกรณี สำหรับผู้ที่มีโรคภูมิแพ้ ฝุ่นละอองสามารถกระตุ้นให้เกิดอาการแพ้ เช่น จาม น้ำมูกไหล และคันตาได้</li>
              <li class="a"><strong>ผลกระทบต่อผิวหนัง:</strong> ฝุ่นละอองสามารถทำให้เกิดการระคายเคืองต่อผิวหนัง โดยเฉพาะในผู้ที่มีผิวแพ้ง่าย หรือมีปัญหาผิวหนังอยู่แล้ว การสัมผัสฝุ่นละอองเป็นเวลานานอาจทำให้ผิวแห้งและคันได้</li>
              <li class="a"><strong>ปัญหาสุขภาพจิต:</strong> บ้านที่สกปรกและเต็มไปด้วยฝุ่นละอองสามารถทำให้เกิดความเครียดและความวิตกกังวลได้ ความรู้สึกไม่สบายใจจากการอยู่ในสภาพแวดล้อมที่ไม่สะอาดอาจส่งผลกระทบต่อสุขภาพจิตในระยะยาว</li>
            </ul>

            <p><img class="img-blog" src="https://beneat.s3.ap-southeast-1.amazonaws.com/blogs/Dust-in-the-house-3.png"></p>

            <h3>วิธีจัดการฝุ่นละอองในบ้านเพื่อสุขภาพที่ดี</h3>
            <h3>1. การทำความสะอาดบ้านเพื่อสุขภาพ</h3>
            <p>การทำความสะอาดบ้านเป็นประจำเป็นวิธีที่ดีที่สุดในการลดปริมาณฝุ่นละอองในบ้าน ควรเริ่มด้วยการดูดฝุ่นที่มีประสิทธิภาพสูงซึ่งสามารถดักจับฝุ่นละอองขนาดเล็กได้ดี เช่น เครื่องดูดฝุ่นที่มีตัวกรอง HEPA (High-Efficiency Particulate Air) ที่สามารถกรองฝุ่นละอองขนาดเล็กได้ถึง 99.97%</p>
            <ul>
              <li class="a"><strong>การดูดฝุ่น:</strong> ควรดูดฝุ่นทุกวันหรืออย่างน้อยสัปดาห์ละ 2-3 ครั้ง โดยเน้นพื้นที่ที่มีฝุ่นละอองสะสมมาก เช่น พื้นพรม โซฟา และเตียงนอน</li>
              <li class="a"><strong>การเช็ดถูพื้น:</strong> ควรใช้ผ้าชุบน้ำหมาดๆ ในการเช็ดถูพื้นเพื่อไม่ให้ฝุ่นละอองฟุ้งกระจาย ทำความสะอาดพื้นผิวเฟอร์นิเจอร์ และพื้นที่ที่ฝุ่นละอองสะสมได้ง่าย เช่น มุมห้อง หรือชั้นวางของ</li>
              <li class="a"><strong>การซักล้าง:</strong> ผ้าม่าน ผ้าปูที่นอน และปลอกหมอนควรซักล้างเป็นประจำ เพราะสิ่งของเหล่านี้สามารถสะสมฝุ่นละอองและสารก่อภูมิแพ้ได้มาก</li>
            </ul>

            <h3>2. เคล็ดลับป้องกันฝุ่นในบ้าน</h3>
            <p>การป้องกันฝุ่นละอองไม่ให้เข้าสู่บ้านเป็นขั้นตอนสำคัญที่ช่วยลดปริมาณฝุ่นในบ้าน:</p>
            <ul>
              <li class="a"><strong>การใช้พรมเช็ดเท้า:</strong> วางพรมเช็ดเท้าหน้าประตูทางเข้าบ้านเพื่อลดปริมาณฝุ่นละอองที่เข้ามาพร้อมกับรองเท้า การถอดรองเท้าก่อนเข้าบ้านเป็นอีกวิธีหนึ่งที่ช่วยลดฝุ่นละอองได้</li>
              <li class="a"><strong>การปิดหน้าต่าง:</strong> เมื่อไม่จำเป็น ควรปิดหน้าต่างเพื่อป้องกันฝุ่นละอองจากภายนอก โดยเฉพาะในช่วงที่มีลมแรงหรือช่วงที่มีการก่อสร้างใกล้เคียง</li>
              <li class="a"><strong>การใช้เครื่องฟอกอากาศ:</strong> เครื่องฟอกอากาศที่มีตัวกรอง HEPA สามารถช่วยกรองฝุ่นละอองในอากาศได้ดี ทำให้อากาศในบ้านสะอาดขึ้น ลดการสะสมของฝุ่นละอองในบ้าน</li>
            </ul>

            <p><img class="img-blog" src="https://beneat.s3.ap-southeast-1.amazonaws.com/blogs/Dust-in-the-house-4.png"></p>

            <h3>3. การบำรุงรักษาและจัดการฝุ่นละอองในบ้าน</h3>
            <p>การบำรุงรักษาบ้านเป็นสิ่งสำคัญในการป้องกันและลดฝุ่นละอองในระยะยาว:</p>
            <ul>
              <li class="a"><strong>การตรวจสอบและเปลี่ยนไส้กรองอากาศ:</strong> ไส้กรองอากาศในเครื่องปรับอากาศและเครื่องฟอกอากาศควรได้รับการตรวจสอบและเปลี่ยนเป็นประจำ เพื่อให้สามารถกรองฝุ่นละอองได้อย่างมีประสิทธิภาพ</li>
              <li class="a"><strong>การทำความสะอาดระบบระบายอากาศ:</strong> ท่อระบายอากาศและพัดลมดูดอากาศควรได้รับการทำความสะอาดเพื่อลดการสะสมของฝุ่นละอองและเชื้อรา</li>
              <li class="a"><strong>การควบคุมความชื้น:</strong> ความชื้นสูงในบ้านสามารถส่งเสริมการเจริญเติบโตของเชื้อราและไรฝุ่น ซึ่งเป็นสาเหตุหลักของกลิ่นอับและอาการแพ้ การใช้เครื่องลดความชื้นสามารถช่วยควบคุมความชื้นในบ้านให้อยู่ในระดับที่เหมาะสม</li>
            </ul>
            
            <p><img class="img-blog" src="https://beneat.s3.ap-southeast-1.amazonaws.com/blogs/Dust-in-the-house-5.png"></p>

            <h3>อันตรายจากบ้านสกปรก: ความเสี่ยงต่อสุขภาพที่คุณต้องรู้</h3>
            <p>บ้านที่สกปรกและเต็มไปด้วยฝุ่นละอองไม่เพียงแต่ทำให้คุณรู้สึกไม่สบายใจ แต่ยังเพิ่มความเสี่ยงต่อการเกิดโรคต่างๆ โดยเฉพาะในกลุ่มผู้ที่มีภูมิคุ้มกันต่ำ เด็กเล็ก ผู้สูงอายุ และผู้ที่มีโรคประจำตัว เช่น โรคหืด โรคภูมิแพ้ และโรคเกี่ยวกับระบบทางเดินหายใจ</p>
            <ul>
              <li class="a"><strong>การสะสมของสารก่อภูมิแพ้:</strong> ฝุ่นละอองเป็นแหล่งสะสมของสารก่อภูมิแพ้ ซึ่งอาจกระตุ้นให้เกิดอาการแพ้ เช่น หายใจลำบาก คันตา และจามได้บ่อยๆ</li>
              <li class="a"><strong>การแพร่กระจายของเชื้อโรค:</strong> บ้านที่สกปรกอาจเป็นแหล่งเพาะเชื้อโรคต่างๆ เช่น เชื้อรา แบคทีเรีย และไรฝุ่น ซึ่งสามารถแพร่กระจายไปยังพื้นผิวต่างๆ และทำให้เกิดการติดเชื้อในร่างกายได้</li>
              <li class="a"><strong>ปัญหาสุขภาพจิต:</strong> ความรู้สึกไม่สบายใจจากการอยู่ในบ้านที่สกปรกและมีฝุ่นละอองมากเกินไปสามารถส่งผลกระทบต่อสุขภาพจิต ทำให้เกิดความเครียดและความวิตกกังวล</li>
            </ul>
            <p>บ้านที่สะอาดและปราศจากฝุ่นละอองเป็นปัจจัยสำคัญที่ช่วยให้คุณและครอบครัวมีสุขภาพที่ดี ฝุ่นละอองในบ้านเป็นภัยเงียบที่สามารถส่งผลกระทบต่อสุขภาพได้อย่างร้ายแรง การทำความสะอาดบ้านเป็นประจำ การใช้เทคนิคป้องกันฝุ่นละออง และการบำรุงรักษาบ้านอย่างถูกวิธีจะช่วยลดปัญหาฝุ่นละอองและทำให้บ้านของคุณเป็นสถานที่ที่ปลอดภัยสำหรับทุกคนในครอบครัว อย่าลืมตรวจสอบบ้านของคุณเป็นประจำและลงมือทำความสะอาดเพื่อให้คุณและคนที่คุณรักมีสุขภาพที่ดีอยู่เสมอ</p>
            <p>หากคุณไม่มีเวลาหรือไม่สะดวกในการทำความสะอาดบ้านเอง บริการแม่บ้านออนไลน์จาก BeNeat เป็นตัวเลือกที่สะดวกสบาย แม่บ้านจาก BeNeat มีความเชี่ยวชาญในการจัดการฝุ่นละอองและรักษาความสะอาดให้บ้านของคุณ ด้วยบริการที่รวดเร็วและมีคุณภาพ คุณสามารถมั่นใจได้ว่าบ้านของคุณจะสะอาดหมดจดและปลอดภัยสำหรับทุกคนในครอบครัว</p> -->

            <!-- <p><img class="img-blog" src="https://beneat.s3.ap-southeast-1.amazonaws.com/blogs/Stains-and-odors-3.png"></p>

            <h3>4. ทำความสะอาดหลังสัตว์เลี้ยงแบบง่ายๆ แต่ได้ผล</h3>
            <p>นอกจากการทำความสะอาดคราบและกลิ่นไม่พึงประสงค์แล้ว การดูแลรักษาสัตว์เลี้ยงให้สะอาดเป็นสิ่งสำคัญที่ไม่ควรมองข้าม การอาบน้ำและแปรงขนสัตว์เลี้ยงอย่างสม่ำเสมอจะช่วยลดปัญหาขนหลุดร่วงและกลิ่นไม่พึงประสงค์</p>
            <h4>การอาบน้ำสัตว์เลี้ยง</h4>
            <ul>
              <li class="a">อาบน้ำสัตว์เลี้ยงอย่างน้อยเดือนละครั้ง ใช้แชมพูเฉพาะสำหรับสัตว์เลี้ยงที่มีส่วนผสมอ่อนโยนเพื่อไม่ให้ระคายเคืองผิวหนัง และหากเป็นไปได้ ควรใช้ครีมนวดเพื่อให้ขนสัตว์เลี้ยงนุ่มลื่นและลดการหลุดร่วงของขน</li>
            </ul>
            <h4>การแปรงขนสัตว์เลี้ยง</h4>
            <ul>
              <li class="a">การแปรงขนสัตว์เลี้ยงทุกวันไม่เพียงช่วยลดขนที่หลุดร่วงในบ้าน แต่ยังช่วยกระตุ้นการไหลเวียนของเลือดและทำให้สัตว์เลี้ยงของคุณมีขนสวยงาม และลดปัญหาขนพันกันหรือก้อนขนที่ทำให้สัตว์เลี้ยงรู้สึกไม่สบาย</li>
            </ul>

            <h3>5. วิธีป้องกันการเกิดคราบและกลิ่นในอนาคต</h3>
            <p>การป้องกันเป็นกุญแจสำคัญในการลดปัญหาคราบและกลิ่นในบ้านที่มีสัตว์เลี้ยง คุณสามารถทำได้โดยการฝึกสัตว์เลี้ยงให้มีนิสัยที่ดี เช่น ฝึกให้ปัสสาวะในที่ที่กำหนด หรือการใช้เสื่อรองที่สามารถซักได้ง่ายในบริเวณที่สัตว์เลี้ยงพักผ่อน เพื่อช่วยลดการสะสมของคราบและกลิ่น</p>
            <h4>การใช้เสื่อรอง</h4>
            <ul>
              <li class="a">ใช้เสื่อรองที่ทำจากวัสดุที่ซักง่ายและไม่ดูดซับกลิ่น เช่น เสื่อพลาสติกหรือเสื่อผ้าฝ้าย วางในบริเวณที่สัตว์เลี้ยงชอบนอนหรือทำกิจกรรม เพื่อป้องกันคราบและกลิ่นที่อาจเกิดขึ้น</li>
            </ul>
            <h4>การทำความสะอาดทันทีเมื่อเกิดคราบ</h4>
            <ul>
              <li class="a">เมื่อเกิดคราบสกปรก ควรรีบทำความสะอาดทันทีเพื่อป้องกันไม่ให้คราบฝังแน่นและกลายเป็นแหล่งสะสมกลิ่นไม่พึงประสงค์</li>
            </ul>
            
            <p><img class="img-blog" src="https://beneat.s3.ap-southeast-1.amazonaws.com/blogs/Stains-and-odors-4.png"></p>

            <p>การดูแลบ้านให้สะอาดหมดจดเป็นเรื่องที่ต้องใช้เวลาและความพยายาม หากคุณต้องการบ้านที่สะอาดและมีเวลาให้กับสัตว์เลี้ยงมากขึ้น BeNeat คือคำตอบของคุณ ด้วยบริการทำความสะอาดบ้านโดยแม่บ้านมืออาชีพที่เชี่ยวชาญด้านการดูแลบ้านที่มีสัตว์เลี้ยง</p>

            <h3><strong>คำถามที่พบบ่อย (FAQ)</strong></h3>
            <p>Q: ทำไมบ้านที่มีสัตว์เลี้ยงจึงมีคราบและกลิ่นง่าย?<br />A: เพราะขนสัตว์หลุดร่วงง่าย, สัตว์เลี้ยงอาจปัสสาวะหรืออาเจียน, และกิจกรรมต่างๆ ของสัตว์เลี้ยงอาจทำให้เกิดคราบสกปรกได้</p>
            <p>Q: อะไรคือสิ่งสำคัญที่สุดในการทำความสะอาดบ้านที่มีสัตว์เลี้ยง?<br />A: การทำความสะอาดอย่างสม่ำเสมอ, การเลือกใช้อุปกรณ์และผลิตภัณฑ์ที่เหมาะสม, และการกำจัดกลิ่นไม่พึงประสงค์</p>
            <p>Q: ทำไมต้องใช้ผลิตภัณฑ์ทำความสะอาดที่ระบุว่าปลอดภัยสำหรับสัตว์เลี้ยง?<br />A: เพื่อป้องกันไม่ให้สัตว์เลี้ยงได้รับอันตรายจากสารเคมีที่เป็นอันตราย</p>
            <p>Q: <strong>BeNeat</strong> มีบริการอะไรบ้างที่เหมาะสำหรับบ้านที่มีสัตว์เลี้ยง?<br />A: บริการทำความสะอาดทั่วไป, บริการขจัดคราบสัตว์เลี้ยง, บริการกำจัดกลิ่น</p>
            -->
            <!-- <h3>การบำรุงรักษาผ้าม่านในระยะยาว</h3>
            <p>การดูแลผ้าม่านไม่เพียงแต่ช่วยให้ผ้าม่านหอมสดชื่นเท่านั้น แต่ยังช่วยยืดอายุการใช้งานของผ้าม่านอีกด้วย ต่อไปนี้คือเคล็ดลับเพิ่มเติมในการดูแลผ้าม่านของคุณ:</p>
            <ul>
              <li class="a"><strong>การเก็บผ้าม่านเมื่อไม่ใช้งาน:</strong> หากคุณไม่ใช้ผ้าม่านในบางช่วงเวลา ควรเก็บผ้าม่านไว้ในที่ที่แห้งและสะอาด หลีกเลี่ยงการเก็บในที่ชื้นหรือที่ที่มีการระบายอากาศไม่ดี</li>
              <li class="a"><strong>การป้องกันแสงแดด:</strong> ผ้าม่านที่โดนแสงแดดแรงๆ อาจทำให้สีซีดจางได้ ควรใช้ม่านกันแสงหรือม่านโปร่งเพื่อป้องกันผ้าม่านหลักจากการโดนแสงแดดโดยตรง</li>
              <li class="a"><strong>การตรวจสอบผ้าม่านเป็นประจำ:</strong>ควรตรวจสอบผ้าม่านว่ามีรอยฉีกขาดหรือสิ่งสกปรกที่ต้องทำความสะอาดหรือไม่ การซ่อมแซมหรือทำความสะอาดทันทีที่พบจะช่วยรักษาสภาพของผ้าม่านได้ดียิ่งขึ้น</li>
            </ul> -->

        <p v-if="blog">💙ビニート💙 𝗕𝗲𝗡𝗲𝗮𝘁 บริการสุดหัวใจ</p>
        <hr>
        <section>
            <h3 class="latest-articles"><strong>บทความล่าสุด</strong></h3>
            <div class="" style="margin-top: 32px; margin-bottom: 124px;" v-if="$mq.phone">
                <div class="">
                    <div class="">
                        <div class="owl-carousel blog-carousel owl-theme homepage">
                            <div class="item" v-for="(item, index) in blogs" :key="index">
                                <cardBlog :item="item"></cardBlog>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else style="margin-bottom: 124px;">
                <Blogs :queryDataPage="0" :queryDataLimit="7" :showInPageConent="true" :blogId="blogId" ></Blogs>
            </div>
        </section>
    </section>
</template>
<script>
import userEventLogHelpers from '../../helpers/userEventLogHelpers'
import Breadcrumb from './components/Breadcrumb.vue'
import Blogs from './components/Blogs.vue'
import axios from 'axios'
import cardBlog from './components/CardBlog.vue'
import 'owl.carousel'

export default {
  components: {
    Breadcrumb,
    Blogs,
    cardBlog
  },
  metaInfo () {
    return {
      title: this.blog ? this.blog.post_title : 'BeNeat - Blog',
      meta: [
        {
          vmid: 'og:title',
          property: 'og:title',
          content: this.blog ? this.blog.post_title : 'BeNeat - Blog'
        },
        {
          vmid: 'description',
          name: 'description',
          content: this.blog ? this.blog.post_description : ''
        },
        {
          vmid: 'og:image',
          name: 'og:image',
          content: this.blog ? this.blog.post_image_url : ''
        },
        {
          vmid: 'image',
          name: 'image',
          content: `${this.blog ? this.blog.post_image_url : ''}`
        },
        {
          vmid: 'og:url',
          property: 'og:url',
          content: this.url
        }
      ]
    }
  },
  data () {
    return {
      blogId: Number(this.$route.params.id),
      blog: null,
      url: null,
      blogs: []
    }
  },
  watch: {
    '$route.params.id': {
      handler: function (id) {
        this.getBlogById(id)
        this.blogId = id
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    async getBlogById (blogId) {
      try {
        this.$swal.showLoading()
        const { data } = await axios.get(`/blog/${blogId}`)
        this.$swal.close()
        if (data.error) {
          this.showErrorMessage('ขออภัยค่ะ ระบบเกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
          return
        }
        this.blog = data.blog
        userEventLogHelpers.logBlogEvent(`blog_detail`, {
          blog_id: this.blog.id,
          blog_title: this.blog.post_title
        })
      } catch (e) {
        this.showErrorMessage('ขออภัยค่ะ ระบบเกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง')
      }
    },
    showErrorMessage (message) {
      this.$swal({
        text: message,
        type: 'error',
        confirmButtonColor: '#2C94BB',
        confirmButtonText: 'ปิด'
      })
    },
    copyURL () {
      navigator.clipboard.writeText(window.location.href)
    },
    async getBlogsData (blogId) {
      this.queryData = {
        page: 0,
        limit: 3
      }
      // console.log('this.queryData', this.queryData)
      const {data} = await axios.get('/blog', { params: this.queryData })
      if (!data.error) {
        let filtered = data.blogs.filter(function (item) {
          console.log('item id', item.id, blogId)
          return item.id !== blogId
        })
        console.log('filtered', filtered)
        this.blogs = filtered
        this.$nextTick(() => {
          this.initOwlCarousel()
        })
      } else {
        console.log('Blogs cannot load: ' + data.message)
      }
    },
    filterBlog () {
      this.blogs = this.blogs.filter(item => item.id !== Number(this.blosId))
      console.log('filterBlog > ', Number(this.blogs))
    },
    async initOwlCarousel () {
      console.log('init owl carousel')
      await window.$('div.owl-carousel').owlCarousel({
        loop: true,
        margin: 30,
        responsiveClass: true,
        nav: false,
        dots: true,
        autoplay: false,
        autoplayTimeout: 7000,
        autoplayHoverPause: true,
        responsive: {
          0: {
            items: 1,
            nav: true,
            loop: true,
            dots: true
          },
          768: {
            items: 2,
            nav: true,
            loop: true,
            dots: true
          },
          1200: {
            items: 3,
            nav: true,
            loop: true
          }
        }
      })

      this.$nextTick(() => {
        window.$('div.blog-carousel div.owl-nav button.owl-prev').css({
          'width': '15px',
          'height': 'auto',
          'position': 'absolute',
          'top': '40%',
          'left': '0',
          'margin-left': '-25px',
          'display': 'block !important',
          'border': '0px solid black'
        }).addClass('no-focus')

        window.$('div.blog-carousel div.owl-nav button.owl-next').css({
          'width': '15px',
          'height': 'auto',
          'position': 'absolute',
          'top': '40%',
          'right': '-25px',
          'display': 'block !important',
          'border': '0px solid black'
        }).addClass('no-focus')

        window.$('div.blog-carousel div.owl-nav button.owl-next i, button.owl-prev i').css({
          'transform': 'scale(2, 2)',
          'color': '#ccc'
        })
      })
    }
  },
  mounted () {
    // this.getBlogById(this.blogId)
    this.getBlogsData(this.blogId)
  },
  created () {
    this.url = window.location.href
    // this.getBlogById(this.blogId)
    this.blogId = Number(this.$route.params.id)
    // console.log('blog id', this.blogId)
    // this.getBlogsData()
  }
}
</script>
<style scoped lang="scss">
@import "~owl.carousel/dist/assets/owl.carousel.css";
@import "~owl.carousel/dist/assets/owl.theme.default.min.css";

#htmlContainer  {
    /deep/ ul {
        margin-left: 60px;
    }
    /deep/ ol {
       margin-left: 60px;
   }
   /deep/ h2 {
        font-size: 20px;
        font-weight: 400;
    }
    /deep/ .img-blog-title {
        width: 100%;
    } 
    /deep/ .img-blog {
        width: 75%;
        display: block;
        margin-left: auto;
        margin-right: auto;
        box-shadow: 0px 4px 4px #00000040;
    }
    /deep/ ul li.a {
      margin-left: 30px;
    }
}
.blogs-list {
    margin-bottom: 124px;
}
hr {
        margin-top: 64px;
        margin-bottom: 64px;
        border: 1px solid #00B4CD;
}
.time {
    background: url('/static/img/Vector.png');
    background-size: 20px 20px;
    position: absolute;
    width: 20px;
    height: 20px;
    margin-left: -27px;
    margin-top: 2px;
}
.detail {
    margin-top: 36px;
}
.img-blog-title {
    margin-top: 32px;
    width: 100%;
}
.created-by {
    font-size: 14px;
    font-weight: 600;
    span {
        color: #7F7F7F !important;
        font-weight: 400 !important;
    }
}
.latest-articles {
    font-size: 24px;
    font-weight: 400;
}
.img-icon-share {
    width: 32px;
    height: 32px;
}


@media (max-width: 425px) {
    #htmlContainer{
        /deep/ .img-blog {
            width: 100%;
            box-shadow: 0px 4px 4px #00000040;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/blogs/Content.vue